/* tslint:disable */
/* eslint-disable */
export enum PackagesOrderByProperty {
  DdtCode = 0,
  CreatedAt = 1,
}
